import * as viewprt from 'viewprt';

var ElementObserver = viewprt.ElementObserver,
    ObserverCollection = viewprt.ObserverCollection;
var debounceCollection = [];

var defaultScrollResizeHandler = function defaultScrollResizeHandler(handler) {
  return handler;
};

var index = (function (element, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? 0 : _options$threshold,
      _options$scrollResize = _options.scrollResizeHandler,
      scrollResizeHandler = _options$scrollResize === void 0 ? defaultScrollResizeHandler : _options$scrollResize,
      _options$onEnter = _options.onEnter,
      _onEnter = _options$onEnter === void 0 ? function () {} : _options$onEnter,
      _options$onExit = _options.onExit,
      _onExit = _options$onExit === void 0 ? function () {} : _options$onExit,
      _options$once = _options.once,
      once = _options$once === void 0 ? false : _options$once;

  var resolvedHandler = debounceCollection.find(function (_ref) {
    var handleScrollResize = _ref.handleScrollResize;
    return scrollResizeHandler === handleScrollResize;
  });

  if (typeof resolvedHandler === 'undefined') {
    resolvedHandler = new ObserverCollection({
      handleScrollResize: scrollResizeHandler
    });
    debounceCollection.push(resolvedHandler);
  }

  var elementObserver = new ElementObserver(element, {
    onEnter: function onEnter(element_) {
      _onEnter(element_);
    },
    onExit: function onExit(element_) {
      _onExit(element_);
    },
    offset: threshold,
    once: once,
    observerCollection: resolvedHandler
  });
  return {
    destroy: elementObserver.destroy.bind(elementObserver)
  };
});

export default index;
//# sourceMappingURL=index.js.map
